import AtomSkeleton, {ATOM_SKELETON_VARIANTS} from '@s-ui/react-atom-skeleton'

const SKELETON_ANIMATION = 'pulse'

const skeleton = [
  {
    ANIMATION: SKELETON_ANIMATION,
    CLASSNAME: 'contentAd-modalImage',
    HEIGHT: '90px',
    WIDTH: '160px'
  },
  {
    ANIMATION: SKELETON_ANIMATION,
    CLASSNAME: 'contentAd-modalTitle',
    HEIGHT: '22px',
    WIDTH: '325px'
  },
  {
    ANIMATION: SKELETON_ANIMATION,
    CLASSNAME: 'contentAd-modalPrice',
    HEIGHT: '22px',
    WIDTH: '160px'
  },
  {
    ANIMATION: SKELETON_ANIMATION,
    CLASSNAME: 'contentAd-modalAttributes',
    HEIGHT: '16px',
    WIDTH: '160px'
  }
]

export const CardAdSkeleton = () => {
  return (
    <>
      {skeleton.map((item, index) => (
        <div className={`mt-CardAd-${item.CLASSNAME}`} key={`${item.CLASSNAME}-${index}`}>
          <AtomSkeleton
            variant={ATOM_SKELETON_VARIANTS.square}
            height={item.HEIGHT}
            width={item.WIDTH}
            style={item.STYLE_SQUARE}
            animation={item.ANIMATION}
          />
        </div>
      ))}
    </>
  )
}

CardAdSkeleton.displayName = 'CardAdSkeleton'
